import React, {useContext} from 'react';
import Form from 'react-bootstrap/Form';
import Tab from 'react-bootstrap/Tab';
import Card from 'react-bootstrap/Card';
import Nav from 'react-bootstrap/Nav';
import { formatMoney } from './utils.js';
import { Context } from './StockManagerContext.jsx';
import { InputGroup } from 'react-bootstrap';

const defaultUpsell = { qty: 0, discount: 0, price: 0 };

export default function OrderLineUpsells({ idx, product, categories, productsByCategory, selectedUpsells, setSelectedUpsells, upsellTotal, setEditing }) {
    const { upsellData } = useContext(Context);

    if (!categories || categories.length === 0) return null;

    return (
        <Tab.Container defaultActiveKey={`#${idx}-${categories[0]}`} id={`upsell-tabs-${product.sku}`}>
        <Card>
            <Card.Header>
                <Nav variant="tabs" >
                    {categories.map(category => {
                        let categoryName = category.replace(/^\d+\.\s*/, '');
                        let isRequired = false;
                        if (categoryName.endsWith('*')) {
                            isRequired = true;
                            categoryName = categoryName.slice(0, -1).trimEnd();
                        }

                        let hasSelection = productsByCategory[category].some(sku => selectedUpsells[sku] && selectedUpsells[sku].qty > 0);
                        return <Nav.Item key={category}>
                                    <Nav.Link eventKey={`#${idx}-${category}`}><span>{categoryName} <span className={`badge ${hasSelection ? 'bg-success' : (isRequired ? 'bg-danger' : 'bg-secondary')}`} style={{color:'white', minWidth: 20}}>{hasSelection ? '✓' : productsByCategory[category].length}</span></span></Nav.Link>
                                </Nav.Item>
                    })}
                </Nav>
            </Card.Header>
            <Card.Body>
                <Tab.Content>
                {categories.map(category => {
                    return <Tab.Pane eventKey={`#${idx}-${category}`} key={category}>
                        <table className="table table-bordered table-striped table-sm" style={{ marginTop: 8 }}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>QTY</th>
                                    <th>Price</th>
                                    <th>Discount</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {productsByCategory[category].map((upsell, idx2) => (
                                    <tr key={`upsell-${category}-${idx2}`}>
                                        <td style={{ width: '100%' }}>
                                            <small>
                                                <span className="badge bg-secondary" style={{ marginRight: 6, color: 'white' }}>{upsell}</span>
                                            </small>
                                            {upsellData.products[upsell]?.['Product Name'] || 'Unknown Product'}
                                            {upsellData.products[upsell]?.['Product Instructions'] && <p><mark>{upsellData.products[upsell]?.['Product Instructions'] || 'No Description'}</mark></p>}
                                        </td>

                                        <td style={{ minWidth: 80, textAlign: 'right' }}>
                                            <Form.Control
                                                value={selectedUpsells[upsell]?.qty || 0}
                                                type="number"
                                                min={0}
                                                onChange={e => {
                                                    const newQty = parseInt(e.target.value) || 0;

                                                    if (newQty > 0) {
                                                        if (!selectedUpsells[upsell]) {
                                                            selectedUpsells[upsell] = { ...defaultUpsell };
                                                        }
                                                        selectedUpsells[upsell].qty = newQty;
                                                        selectedUpsells[upsell].price = parseFloat(upsellData.products[upsell]?.['DefaultPrice']) || 0;
                                                    } else if (selectedUpsells[upsell]) {
                                                        // Don't delete the upsell, so we don't lose discount info
                                                        selectedUpsells[upsell].qty = 0;
                                                    }

                                                    setSelectedUpsells({ ...selectedUpsells });
                                                }}
                                            />
                                        </td>

                                        {/* Price input */}
                                        <td style={{ textAlign: 'right', minWidth: 140 }}>
                                            {selectedUpsells[upsell]?.qty > 0 && (
                                            <InputGroup>
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>$</InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    value={selectedUpsells[upsell]?.price.toString()}
                                                    min={0}
                                                    style={{ minWidth: 80 }}
                                                    type="number"
                                                    onChange={e => {
                                                        const newPrice = parseFloat(e.target.valueAsNumber) || 0;
                                                        if (!selectedUpsells[upsell]) {
                                                            selectedUpsells[upsell] = { ...defaultUpsell };
                                                        }
                                                        selectedUpsells[upsell].price = newPrice;
                                                        console.log('Setting price for upsell', upsell, 'to', newPrice, selectedUpsells[upsell]);
                                                        setSelectedUpsells({ ...selectedUpsells });
                                                    }}
                                                />
                                            </InputGroup>
                                            )}
                                        </td>

                                        {/* Discount input */}
                                        <td style={{ textAlign: 'right', minWidth: 140 }}>
                                            {selectedUpsells[upsell]?.qty > 0 && (
                                            <InputGroup>
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>$</InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    value={selectedUpsells[upsell]?.discount.toString() || ''}
                                                    min={0}
                                                    style={{ minWidth: 80 }}
                                                    type="number"
                                                    onChange={e => {
                                                        const newDiscount = parseFloat(e.target.valueAsNumber) || 0;
                                                        if (!selectedUpsells[upsell]) {
                                                            selectedUpsells[upsell] = { ...defaultUpsell };
                                                        }
                                                        selectedUpsells[upsell].discount = newDiscount;
                                                        console.log('Setting discount for upsell', upsell, 'to', newDiscount, selectedUpsells[upsell]);
                                                        setSelectedUpsells({ ...selectedUpsells });
                                                    }}
                                                />
                                            </InputGroup>
                                            )}
                                        </td>

                                        <td style={{ textAlign: 'right' }}>{formatMoney((selectedUpsells[upsell]?.price||upsellData.products[upsell]?.['DefaultPrice']) *  selectedUpsells[upsell]?.qty - (selectedUpsells[upsell]?.discount || 0))}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Tab.Pane> }
                )}
                </Tab.Content>
                <button className="btn btn-secondary" onClick={e => {
                    e.preventDefault();
                    setEditing(false);
                }}>Close</button>
                <span style={{ float: 'right', lineHeight: '32px' }}>Add-on total: <strong>{formatMoney(upsellTotal)}</strong></span>
            </Card.Body>
        </Card>
        </Tab.Container>
    );
}
